import Typography from "@mui/material/Typography";

import ReadoutsHero from "@app/analytics/assets/auth/readouts_hero.png";

import { NewBadge } from "@rui/FeatureBadge";
import { Column } from "@rui/Stack";
import { Img, Span } from "@rui/styles";

import {
  ImageContainer,
  UpsellContentContainer,
  UpsellImageContainer,
  UpsellPanelTitle,
} from "./styles";

const UpsellContent = () => {
  return (
    <UpsellContentContainer>
      <Column variant="center" spacing={2} maxHeight="100%">
        <NewBadge />
        <UpsellPanelTitle>
          AI-Powered Email and Messaging Summaries
        </UpsellPanelTitle>
        <UpsellImageContainer>
          <ImageContainer>
            <Img
              src={ReadoutsHero}
              alt="AI-Powered Email and Messaging Summaries"
              maxWidth="100%"
              height="100%"
            />
          </ImageContainer>
        </UpsellImageContainer>
        <Typography
          variant="bodyPrimaryMed"
          color="transparent.white.70"
          textAlign="center"
        >
          Free with every Read account! <br /> Activate in{" "}
          <Span color="#FFF">Apps & Integrations &gt; Productivity</Span>
        </Typography>
      </Column>
    </UpsellContentContainer>
  );
};

export default UpsellContent;
